import { ReadonlyURLSearchParams } from 'next/navigation';

export const getIsMobileClient = (searchParams: URLSearchParams | ReadonlyURLSearchParams | null) => {
	const deviceType = searchParams?.get('device_type');

	return typeof deviceType === 'string' && ['ios', 'android'].includes(deviceType);
};
